import React, { useState, useEffect } from 'react';
// import moment from 'moment'

import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { es } from 'date-fns/locale'

// estilos
import '../../assets/style/componentPrincipal.css'
import './compras.css'
import '../../assets/style/tablesG.css'

// componentes
// import { Buscar } from '../general/buscadorGastos/Buscar';
import { ModalProgress } from '../modals/ModalProgress';
// import { VerReporte } from '../general/buscadorGastos/verReporte/VerReporte';
import { TableList } from './tableList';

import { useBuy } from '../../hooks/useBuy'
// import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import NumberFormat from 'react-number-format';

export const ComprasReport = () => {

    const isMobile = useMediaQuery('(max-width:768px)');
    const [loading, setLoading] = useState(true)
    const { buys, initGetAllBuy } = useBuy()

    const [filters, setFilters] = useState({
        time: 'month',
        text: '',
        fecha_desde: new Date(),
        fecha_hasta: new Date(),
        check_emitida: true,
        check_pagada: true,
        check_anulada: false,
        check_abonado: false,
        check_justificado: false,
        origen: '',
        page: 1,
        rows: 10
    })

    const handleChangeDateDesde = (newValue) => {
        setFilters({
            ...filters,
            fecha_desde: newValue
        })
    }

    const handleChangeDateHasta = (newValue) => {
        // console.log(newValue)
        setFilters({
            ...filters,
            fecha_hasta: newValue
        })
    }

    useEffect(() => {
        setLoading(true)
        initGetAllBuy(filters)
        setLoading(false)
    }, [filters, initGetAllBuy])

    return (
        <div className='container-fluid'>

            <div className="row">
                <div className="col">
                    <h1 className='p-title'>Gastos report</h1>
                </div>
            </div>

            <div className='p-2'>
                <DateFilters
                    filters={filters}
                    setFilters={setFilters}
                    handleChangeDateDesde={handleChangeDateDesde}
                    handleChangeDateHasta={handleChangeDateHasta}
                    isMobile={isMobile}
                />
            </div>

            {loading && <ModalProgress />}

            {/* <div className='row p-box-filters'>
                <div className='col p-box-filters-items'>
                    <Link to="/gastos/pptos">Ver presupuestos de gastos</Link>
                </div >
            </div> */}

            <div className='row'>
                <div className="col col-lg-12 col-xl-4">
                    <div className="m-1 p-3" style={{ borderRadius: '10px', backgroundColor: 'white' }}>
                        <Resumen />
                        <ProgressBar />
                        <Disponible />
                    </div>
                </div>
            </div>

            <TableList
                filters={filters}
                setFilters={setFilters}
                list={buys}
            />

        </div >
    )
}

const DateFilters = ({ filters, setFilters, handleChangeDateDesde, handleChangeDateHasta, isMobile }) => {
    return (
        <>
            {/* <div className="row mt-3">
                <div className="col text-start">
                    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                        <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off"
                            checked={filters.time == 'year' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'year' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio1" style={{ color: filters.time == 'year' ? '#8E24AA' : '#595759' }}>
                            Anual ({moment(filters.fecha_desde).format('YYYY')})
                        </label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off"
                            checked={filters.time == 'month' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'month' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio2" style={{ color: filters.time == 'month' ? '#8E24AA' : '#595759' }}>
                            Mensual (<span style={{ textTransform: 'capitalize' }}>{moment(filters.fecha_desde).format('MMMM')}</span>{' '}{moment(filters.fecha_desde).format('YYYY')})
                        </label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off"
                            checked={filters.time == 'range' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'range' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio3" style={{ color: filters.time == 'range' ? '#8E24AA' : '#595759' }}>
                            Rango
                        </label>
                    </div>
                </div>
            </div> */}

            {filters.time === 'year' &&
                <div className='mt-4 p-text-date-year'>
                    <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={['year']}
                            label="Año"
                            openTo="year"
                            name='fecha_desde'
                            // minDate={new Date('2020-01-01')}
                            value={filters.fecha_desde}
                            onChange={handleChangeDateDesde}
                            renderInput={(params) => <TextField {...params} helperText={null} />}
                        />
                    </LocalizationProvider>
                </div>
            }

            {filters.time === 'month' &&
                <div className='mt-4 p-text-date-month'>
                    <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                        {isMobile ?
                            <MobileDatePicker
                                views={['year', 'month']}
                                label="Mes"
                                openTo="month"
                                name='fecha_desde'
                                // minDate={new Date('2020-01-01')}
                                value={filters.fecha_desde}
                                onChange={handleChangeDateDesde}
                                renderInput={(params) => <TextField {...params} helperText={null} />}
                            />
                            :
                            <DatePicker
                                views={['year', 'month']}
                                label="Mes"
                                openTo="month"
                                name='fecha_desde'
                                // minDate={new Date('2020-01-01')}
                                value={filters.fecha_desde}
                                onChange={handleChangeDateDesde}
                                renderInput={(params) => <TextField {...params} helperText={null} />}
                            />
                        }
                    </LocalizationProvider>
                </div>
            }

            {filters.time === 'range' &&
                <div className="row mt-4">
                    <div className="col text-start d-flex justify-content-start p-text-date-range">
                        <span>
                            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={['year', 'month']}
                                    label="Mes desde"
                                    openTo="month"
                                    name='fecha_desde'
                                    // minDate={new Date('2020-01-01')}
                                    value={filters.fecha_desde}
                                    onChange={handleChangeDateDesde}
                                    renderInput={(params) => <TextField {...params} helperText={null} />}
                                />
                            </LocalizationProvider>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={['year', 'month']}
                                    label="Mes hasta"
                                    openTo="month"
                                    name='fecha_hasta'
                                    // minDate={new Date('2020-01-01')}
                                    value={filters.fecha_hasta}
                                    onChange={handleChangeDateHasta}
                                    renderInput={(params) => <TextField {...params} helperText={null} />}
                                />
                            </LocalizationProvider>
                        </span>
                    </div>
                </div>
            }

        </>
    )

}

const Resumen = () => {
    return (
        <div className='d-flex justify-content-between'>
            <div className='d-flex flex-column justify-content-between'>
                <span>Presupuesto:</span>
                <NumberFormat
                    value={4500}
                    displayType={'text'}
                    thousandSeparator=","
                    decimalSeparator="."
                    prefix="S/ "
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </div>
            <div className='d-flex flex-column justify-content-between'>
                <span>Gasto actual:</span>
                <NumberFormat
                    value={4500}
                    displayType={'text'}
                    thousandSeparator=","
                    decimalSeparator="."
                    prefix="S/ "
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </div>
        </div>
    )
}

const ProgressBar = () => {
    return (
        <div className="row progreso mt-2">
            <div className="col">
                <div className="progress">
                    <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: `10%` }}
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100">
                    </div>
                </div>
            </div>
        </div>
    )
}

const Disponible = () => {
    return (
        <div className="d-flex justify-content-start mt-2">
            <div>
                <span>Disponible:</span>
                <NumberFormat
                    className="ms-1"
                    value={100}
                    displayType={'text'}
                    thousandSeparator=","
                    decimalSeparator="."
                    prefix="S/ "
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </div>
        </div>
    )
}